import {
  getLocalStorageValue,
  setLocalStorageValue,
} from '~/utils/localStorageClient'

const STORAGE = { key: 'adminLastMenu', initialValue: null }

export function saveLastAdminMenu(value: string) {
  setLocalStorageValue(STORAGE, value)
}

/** The last admin menu the user viewed if it's still visible, else the first. */
export function getInitialAdminMenu<T extends string>(
  visibleMenus: readonly T[],
): T | undefined {
  const last = getLocalStorageValue<string | null>(STORAGE)
  return visibleMenus.find((m) => m === last) ?? visibleMenus[0]
}
